module.exports = __webpack_public_path__ + "media/icons/slash-fa899dc6a531055afd9d3460573ae95d.svg";